import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Public from './components/shared/Public';
import Private from './components/shared/Private';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import LoginScreen from './components/screens/auth/LoginScreen';
import Dashboard from './components/screens/Dashboard';
import Users from './components/screens/Users';
import { AuthProvider } from './contexts/AuthProvider';
import AxiosProvider from './interceptors/AxiosProvider';
import Sites from './components/screens/Sites';
import Shifts from './components/screens/Shifts';
import Schedules from './components/screens/Schedules';
import DatabaseAdministration from './components/screens/DatabaseAdministration';
import Settings from './components/screens/Settings';
import Checkpoints from './components/screens/Checkpoints';
import PatrolLogs from './components/screens/PatrolLogs';
import ForgotPassword from './components/screens/auth/ForgotPassword';
import ResetPassword from './components/screens/auth/ResetPassword';
import Cities from './components/screens/Cities';
import Clients from './components/screens/Clients';
import SecurityLogs from './components/screens/SecurityLogs';
import IncidentReports from './components/screens/IncidentReports';
import IncidentDetail from './components/screens/IncidentDetail';
import Reports from './components/screens/Reports';
import ReportPage from './components/reports/ReportPage';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      {/** for public routes */}
      <Route path='' element={<Public />}>
        <Route path='/login' element={<LoginScreen />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:email/:token' element={<ResetPassword />} />
      </Route>

      {/** for private(protected) routes */}
      <Route path='' element={<Private />}>
        <Route path='/' element={<Dashboard />} index={true} />
        <Route path='/users' element={<Users />} />
        <Route path='/sites' element={<Sites />} />
        <Route path='/shifts' element={<Shifts />} />
        <Route path='/schedules' element={<Schedules />} />
        <Route path='/database-administration' element={<DatabaseAdministration />} />
        <Route path='/settings' element={<Settings />} />
        <Route path='/checkpoints' element={<Checkpoints />} />
        <Route path='/patrol-logs' element={<PatrolLogs />} />
        <Route path='/cities' element={<Cities />} />
        <Route path='/clients' element={<Clients />} />
        <Route path='/duty-logs' element={<SecurityLogs />} />
        <Route path='/incident-reports' element={<IncidentReports />} />
        <Route path='/incidents/:id' element={<IncidentDetail />} />
        <Route path='/reports' element={<Reports />} />
        <Route path='/operational-reports' element={<ReportPage />} />
      </Route>
    </Route>
  )
)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AxiosProvider>
        <RouterProvider router={router} />
      </AxiosProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
